module.exports = __webpack_public_path__ + "img/morning.9a39a665.svg";